import { jsx as _jsx } from "react/jsx-runtime";
import { Suspense, lazy, StrictMode } from "react";
import { render } from "react-dom";
import(/*  webpackPreload: true */ "bootstrap/dist/css/bootstrap.min.css");
import(/*  webpackPreload: true */ "@/assets/scss/index.scss");
const Layout = lazy(() => import("./components/layout/index"));
render(_jsx(StrictMode, { children: _jsx(Suspense, { fallback: _jsx("div", { children: "Loading..." }, void 0), children: _jsx(Layout, {}, void 0) }, void 0) }, void 0), document.getElementById("root"));
